import type { ChangeEvent } from "react";
import { RadioGroup, Radio } from "@certa/catalyst/components/Radio";
import { BOOLEAN_FILTER_OPTIONS } from "../TableFilters.constants";
import { useFilterOverlay } from "../FilterOverlay/FilterOverlayContext";

const BooleanFilter = () => {
  const { label, searchValue, setSearchValue } = useFilterOverlay();

  const handleChange = (evt: ChangeEvent<HTMLInputElement>) => {
    const selectedValue = evt.target.value;
    const isChecked = evt.target.checked;

    if (isChecked) {
      setSearchValue(selectedValue);
    }
  };

  return (
    <div style={{ minWidth: "10rem" }}>
      <RadioGroup
        name={label}
        aria-label={label}
        direction="vertical"
        onChange={handleChange}
        value={searchValue}
      >
        {BOOLEAN_FILTER_OPTIONS.map(item => {
          return (
            <Radio
              key={item.value}
              checked={!!searchValue?.includes(String(item.value))}
              label={item.label}
              value={item.value}
            />
          );
        })}
      </RadioGroup>
    </div>
  );
};

export { BooleanFilter };
